import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useEffect, useState } from "react";
import { useUpdateWindhostingSite, useWindhostingSite, useWindhostingSiteWebserverInfo } from "@hostingbv/lib/src/api/partner/PartnerHooks";
import { ValidationError } from "@hostingbv/lib/src/api/ModelFactory";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";
import { Site } from "@hostingbv/lib/src/api/partner/models/Site";
import { SiteConfig } from "@hostingbv/lib/src/api/partner/models/windhosting/SiteConfig";
import { webserverConfigExamples } from "@hostingbv/lib/src/api/partner/models/windhosting/WebserverInfo";

export const WindhostingSiteWebserverConfigModal: FC<{ site: Site }> = ({ site }) => {
  const [config, setConfig] = useState("")
  const [deploymentError, setDeploymentError] = useState("")

  const { data } = useWindhostingSite(site.serverId, site.id)
  const { data: info } = useWindhostingSiteWebserverInfo(site.serverId, site.id)
  useEffect(() => setConfig(data?.webserverConfig ?? ""), [data])

  const { mutate, error } = useUpdateWindhostingSite(site.serverId, site.id)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const save = async () => {
    if (!data) return
    const deployment = await mutate(new SiteConfig(data.certificate, data.phpVersion, data.phpPoolConfig, config, data.aliasDomains));

    const updatedDeployment = await awaitNextDeploymentFinished(deployment.id)
    if (updatedDeployment?.status === "failed") {
      // @ts-expect-error output is untyped
      setDeploymentError(updatedDeployment?.output?.message ?? 'Invalid configuration')
      throw Error("deployment failed");
    }
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <div>
        <span className={'text-sm font-medium text-brand-900'}>webserver.conf</span>
        <div className={'border-2 border-slate-200 rounded-sm mt-1 flex flex-col items-stretch'}>
          <textarea
            autoFocus={true}
            className={`outline-hidden text-black rounded-sm font-normal px-2 py-2 h-72 text-xs font-mono`}
            placeholder={info ? webserverConfigExamples[info.component] : ''}
            value={config}
            onChange={(e) => setConfig(e.target.value)}
          />
        </div>
        {info?.component === 'nginx' && <div className={'text-xs text-slate-500 mt-1'}>
          Added to the https server block. <code>root</code> and <code>location /</code> can't be overridden.
        </div>}
        {error instanceof ValidationError && <div className={"px-3 py-2 bg-red-50 rounded-sm my-4 text-sm text-red-900"}>
          {error.message}
        </div>}
        {deploymentError !== '' && <div className={"px-3 py-2 bg-red-50 rounded-sm my-4 text-sm text-red-900"}>
          {deploymentError}
        </div>}
      </div>
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
